import { render, staticRenderFns } from "./MenuPhysiotherapist.vue?vue&type=template&id=0a93cc08&"
import script from "./MenuPhysiotherapist.vue?vue&type=script&lang=js&"
export * from "./MenuPhysiotherapist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports